import { FLEET_LOADED, FLEET_CLEAR, ATTENTION_DISMISS } from '../actions/fleetActions';

// Not persisted: hubs and staff are class instances, and stale ones would
// show problems that have since been fixed.
const initialState = {
  hubs: null,
  staff: null,
  // Attention item ids dismissed this session.
  dismissed: {}
};

const fleet = (state = initialState, action) => {
  switch (action.type) {
    case FLEET_LOADED:
      return {
        ...state,
        ...(action.hubs !== undefined ? { hubs: action.hubs } : {}),
        ...(action.staff !== undefined ? { staff: action.staff } : {})
      };
    case ATTENTION_DISMISS:
      return { ...state, dismissed: { ...state.dismissed, [action.id]: true } };
    case FLEET_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default fleet;
